module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n  Connect to your device Wi-Fi AP. It should be named something like "), _c('strong', [_vm._v("Homie-123456abcdef")]), _vm._v(".\n  Note this configurator is only for Homie for ESP8266 v2. The v1 configurator is available "), _c('a', {
    attrs: {
      "href": "https://github.com/marvinroger/homie-esp8266/releases/download/v1.5.0/homie-esp8266-v1-setup.zip"
    }
  }, [_vm._v("here")]), _vm._v(".\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfdb7a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Connection.vue
// module id = 56
// module chunks = 0